import { render, staticRenderFns } from "./AxxessLtePricing.vue?vue&type=template&id=a87b5498&scoped=true&"
import script from "./AxxessLtePricing.vue?vue&type=script&lang=js&"
export * from "./AxxessLtePricing.vue?vue&type=script&lang=js&"
import style0 from "./AxxessLtePricing.vue?vue&type=style&index=0&id=a87b5498&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87b5498",
  null
  
)

export default component.exports